<template>
  <div class="dashboard-header element-background-color navbar">
    <!-- Burger: 0-200px -->
    <div class="dashboard-header__burger">
      <div class="navbar-minimize d-inline">
        <LayoutSidebarToggleButton />
      </div>
      <div class="navbar-toggle d-inline" :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
    </div>

    <!-- Logo: ab 200px, flexibel -->
    <div class="dashboard-header__logo">
      <NuxtLink to="/" title="DATENBANKGESTALTER.DE">
        <img src="/img/mydb_logo.png">
      </NuxtLink>
    </div>

    <!-- Avatar: 300px rechts -->
    <div class="dashboard-header__avatar">
      <AccountIcon with-help-link></AccountIcon>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useSidebar} from "~/modules/common/stores/sidebar";

const $sidebar = useSidebar();

const toggleSidebar = () => {
  $sidebar.displaySidebar(!$sidebar.showSidebar);
};
</script>

<style scoped>
.dashboard-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 56px;
  position: sticky;
  top: 0;
  z-index: 1030;
}

.dashboard-header__burger {
  width: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-header__logo {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.dashboard-header__logo img {
  max-height: 40px;
  max-width: 100%;
  width: auto;
  height: auto;
}

.dashboard-header__avatar {
  width: 100px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 16px;
}
</style>

